import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  isXs = false;
  isMobile = false;
  isTablet = false;
  isDesktop = false;
  isLarge = false;

  update(width: number) {
    this.isXs = width < 576;
    this.isMobile = width < 768;
    this.isTablet = width >= 768 && width < 992;
    this.isDesktop = width >= 992 && width < 1200;
    this.isLarge = width >= 1200;
  }
}
